function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import c from 'classnames';
import RangeField from '../RangeField';
import NumberField from '../NumberField';
import Tooltip from '../../Tooltip';
const RangeWithInputField = _ref => {
  let {
    name,
    className,
    label,
    description,
    tooltip,
    accuracy = 0,
    horizontal = true,
    onChange,
    onTooltipOpen,
    onTooltipClose,
    allowOutOfBounds,
    allowDecimals,
    ...props
  } = _ref;
  const classNames = c('RangeWithInputField', 'form-item', className);
  const containerClasses = c('RangeWithInputField__container', {
    RangeWithInputField__container__horizontal: horizontal
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, label && /*#__PURE__*/React.createElement("div", {
    className: "RangeWithInputField__label"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: name
  }, label), tooltip && /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltip,
    onOpen: onTooltipOpen,
    onClose: onTooltipClose
  })), description && /*#__PURE__*/React.createElement("span", {
    className: "description"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React.createElement(RangeField, _extends({
    name: name,
    accuracy: accuracy,
    visualValidation: false,
    verticalSpacing: !horizontal,
    onChange: e => onChange && onChange(e, 'RangeField'),
    hideValidationMessage: true
  }, props)), /*#__PURE__*/React.createElement(NumberField, _extends({
    name: name,
    accuracy: accuracy,
    visualValidation: false,
    verticalSpacing: false,
    onChange: e => onChange && onChange(e, 'NumberField'),
    allowOutOfBounds: allowOutOfBounds,
    allowDecimals: allowDecimals
  }, props))));
};
export default RangeWithInputField;